import * as constants from '../constants';

export function setMonthlyOverview(payload) {
  return {
    type: constants.SET_MONTHLY_OVERVIEW,
    payload,
  };
}
